import Header from "../components/header";
import Footer from "../components/footer";
import CourseItems from "../components/courseitems";
import { Component } from "react";
import { Link } from "react-router-dom";

class Course extends Component {
    constructor(props) {
        super(props);
        this.state = {
            courseItems: []
        };
        document.title = "Podcasting Course in Sydney | Become a Podcaster | Voicecoach.net";
    }

    componentDidMount() {
        window.scroll(-1, 0);
        fetch('https://api.voicecoach.net/courselist')
        .then(res => res.json())
        .then(jr => { this.setState({courseItems: jr}) })
    }

    render() {
        return <>
<Header />
<section className="text-bg-vc">
    <div className="container pt-5">
        <div className="row flex-column-reverse flex-lg-row">
            <div className="col-lg-5 col-12">
                <div className="text-center tagline">
                        <h2 data-aos="zoom-in">Learn The Game!</h2>
                        <h3 data-aos="zoom-in">Earn The Fame!</h3>
                </div>
            </div>
            <div className="col-lg-7 col-12">
            <img src="/img/podcast-success.svg" alt="Podcast training in Sydney" className="w-100" />
            </div>
        </div>
    </div>
</section>
<section className="text-bg-vc-white container">
    <div className="row">
        <div className="col-12">
        <h1 className="pt-5 bolder" data-aos="fade-up-left">Welcome to your Podcasting Course!</h1>
        </div>
        </div>
        <div className="row my-5">
        <div className="col-12">
        <p data-aos="fade-up-right">You will learn everything you need to know to deliver compelling, engaging content that captures your audience's attention and keeps them coming back for more...</p>
        </div>
        </div>
        <div className="row">
            <div className="col-12">
            <h3 data-aos="fade-down" className="display-5">Key Features</h3>
            </div>
            <div className="col-12 fade-up overflow-hidden">
    <ul className="features list-group list-group-flush pb-5 pt-3">
        <CourseItems data={this.state.courseItems} />
    </ul>
<p>The list above is just the beginning!</p>
<p>This course is packed with tonnes of additional tips, tricks, and techniques to help you take your podcasting skills to the next level!</p>
<p>Get ready to transform your podcasting game and create content that keeps your fans engaged!</p>
            </div>

            <div className="col-12 my-5">
                <h3 data-aos="fade-down" className="display-5 mb-3">Schedule and Cost</h3>
                <div className="d-block d-md-none mt-3 mb-2">
                ⟵ Swipe the table below ⟶
                </div>
                <div className="overflow-auto w-100">
                <table className="table table-bordered">
                    <thead><tr><th>Course</th>
                            <th>Code</th>
                            <th>Duration</th>
                            <th>Location</th>
                            <th>Cost (inc gst)</th>
                            <th>Type</th></tr></thead>
                    <tbody>
                        <tr><td>Podcasting</td><td>YPC</td><td>3 x 1 hr sessions</td><td>Studio</td><td>$880</td><td>Individual</td></tr>
                        <tr><td>Podcasting-Group</td><td>YPG</td><td>1 x 3 hr session</td><td>Studio</td><td>$550 pp</td><td>Group</td></tr>
                        <tr><td>Podcasting-Online</td><td>YPO</td><td>3 x 1 hr sessions</td><td>Online</td><td>$880</td><td>Individual</td></tr>
                    </tbody></table>
                    </div>
                </div>
        </div>
    <div className="row my-5"><div className="col-lg-12 aos-init aos-animate" data-aos="zoom-in"><p className="text-center">
        <Link to="/booking" className="btn big-button btn-primary">Start Learning</Link></p></div></div>
</section>
<Footer />
</>
    }
}

export default Course